module.exports = __webpack_public_path__ + "src/routes/aboutus/diagnosis.png?6dbdc224";


//////////////////
// WEBPACK FOOTER
// ./src/routes/aboutus/diagnosis.png
// module id = 2831
// module chunks = 1